module.exports = __webpack_public_path__ + "img/GEG_80X30.f1b018c9.png";